import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid2, Box, Typography, Paper, Button, IconButton ,Snackbar, Alert} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { getPrompts,destroyPrompt } from "../../actions/promptStoreAction";
import { Link, useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import AddButton from "../../themes/overrides/AddButton";
import SearchField from "../../themes/overrides/SearchField";
import WorkspaceIcon from "../../assets/images/workspace_black.svg";
import LoadingOverlay from "../../components/LoadingOverlay";
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';

import EditIcon from "../../components/icons/EditIcon";
import RemoveIcon from "../../components/icons/RemoveIcon";
import DeleteConfirmationModal from "../../components/DeleteConfirmationModal";
import CreatePromptForm from "./CreatePromptForm";
import EditPromptForm from "./EditPromptForm";

const PromptLibrary = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [shouldRefresh, setShouldRefresh] = useState(true);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const propmpts = useSelector((state) => state.prompts.prompts);
  const availableAiModels = useSelector(
    (state) => state.workspace.workspaceInfo?.data?.aiModels
  );
  console.log(availableAiModels);
  const [variables, setVariables] = useState({});
  const { workspaceId } = useParams();

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedPrompt, setSelectedPromptDelete] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const [openEditModal, setOpenEditModal ] = useState(false);
  const [selectedPromptId, setSelectedPromptId] = useState('');
  
  useEffect(() => {
    if (shouldRefresh && workspaceId ) {
      setLoading(true);
      // dispatch(getPrompts(workspaceId));
      // setShouldRefresh(false);
      Promise.all([
        dispatch(getPrompts(workspaceId)),
      ]).finally(() => setLoading(false));
      setShouldRefresh(false);
    }
  
  }, [workspaceId,shouldRefresh, dispatch]);

  const handleSearch = (event) => {
    setSearchTerm(event.target.value.toLowerCase());
  };


  const columns = [
    { field: "promptName", headerName: "Prompt Name", flex: 1 },
    { field: "category", headername: "Category", flex: 1 },
    {
      field: "actions",
      headername: "Action",
      flex: 1,
      sortable: false,
      renderCell: (params) => (
        <Box>
          <IconButton
          color="secondary"
            onClick={() => handleOpenEditModal(params.row._id)}
            aria-label="edit"
          >
            <EditIcon/>
          </IconButton>
          <IconButton
            color="secondary"
            onClick={() => handleDeletePrompt(params.row._id)}
            aria-label="delete"
            // disabled={!hasPermission('admin')}
          >
            <RemoveIcon/>
          </IconButton>
        </Box>
      ),
    },
    {
      field: "execute",
      headername: "Execute",
      flex: 1,
      sortable: false,
      renderCell: (params) => (
        <Button color="primary" variant="contained" onClick={()=>navigatePromptGenerator(params)}>
          Generate
        </Button>
      ),
    },
  ];

  const filteredRows = Array.isArray(propmpts)
    ? propmpts
        .filter((propmpts) => {
          const promptName = propmpts?.promptName || "";

          return promptName.toLowerCase().includes(searchTerm);
        })
        .map((propmpt, index) => ({
          id: index,
          promptName: propmpt?.promptName || "Untitled",
          category: propmpt?.category || "Untitled",

          createdBy: Array.isArray(propmpt?.createdBy)
            ? propmpt.createdBy[0]?.name || "N/A"
            : "N/A",
          _id: propmpt._id,
        }))
    : [];
  
  const navigatePromptGenerator = (params) => {
    try {
      if (availableAiModels === undefined){
          setSnackbar({ open: true, message: " You don't have any AI Integration", severity: "error" });
          return;
      }
      const paramId = params.row._id;
       navigate(`/${workspaceId}/prompt/${paramId}/template`);
    } catch (error){

    }
  }
  const handleCloseSnackbar = () => setSnackbar({ ...snackbar, open: false });

  const handleDeletePrompt = (id) => {
    setSelectedPromptDelete(id);
    setDeleteModalOpen(true);
    
  }

  const handleOpenEditModal = (id) => {
      setOpenEditModal(true);
      setSelectedPromptId(id);
  }

  const handleConfirmDelete = async () => {
    try {
      console.log(selectedPrompt);
      await dispatch(destroyPrompt(selectedPrompt));

      setSnackbar({ open: true, message: "Prompt deleted successfully!", severity: "success" });

    } catch(error) {
      setSnackbar({ open: true, message: "Failed to delete prompt.", severity: "error" });

    } finally {
      setDeleteModalOpen(false);
      setSelectedPromptDelete(null);

    }
  }

  const openPopup = () => {
    setModalOpen(true);
  };


  const handlePopupSuccess = () => {
    setModalOpen(false);
    setShouldRefresh(true);
  }

  const handleEditModalClose = () => {
    setOpenEditModal(false);
    setSelectedPromptId('');

  }

  return (
    <Grid2 container spacing={2} alignItems="center">
      <Grid2 container size={12} display="flex" justifyContent="space-between">
        <Grid2
          size={{ xs: 12, md: 8 }}
          display="flex"
          alignItems="flex-start"
          sx={{ marginLeft: { xs: 4, md: 0 } }}
        >
          <Box
            component="img"
            sx={{ width: { xs: 32, md: 40 }, marginRight: { xs: 2, md: 4 } }}
            src={WorkspaceIcon}
          />
          <Typography variant={"h1"}>Prompt Library</Typography>
        </Grid2>
        <Grid2
          size={{ xs: 12, md: 4 }}
          offset={{ xs: 4, md: 0 }}
          display="flex"
          justifyContent="flex-end"
        >
          <AddButton
            // component={Link}
            onClick={openPopup}
            label="Create a New propmpt"
            sx={{ mr: 1 }}
            to={`/${workspaceId}/prompt-create`}
          />
        </Grid2>
      </Grid2>
      <Grid2 size={12} container spacing={2} alignItems="center">
        <Grid2
          container
          spacing={2}
          alignItems="center"
          sx={{ marginTop: isMobile ? 4 : 0 }}
        >
            <Grid2 size={12}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
                flexGrow: 1
              }}>

              <Grid2 size={{ xs: 12, md: 4 }}>
                <SearchField
                  placeholder="Search prompt"
                  variant="outlined"
                  fullWidth
                  value={searchTerm}
                  onChange={handleSearch}
                  sx={{ flex: 1 }}
                />
              </Grid2>
            </Box>
          </Grid2>
          <Grid2 size={4}>
          </Grid2>

          <Grid2 size={4}></Grid2>
          <Grid2 size={12}>
            <Paper
              elevation={2}
              sx={{
                padding: 2,
                marginBottom: 2,
                marginTop: { md: 2 },
                overflowX: "auto",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  minWidth: { xs: 600, md: "100%" },
                  minHeight: 100,
                  alignContent: "center",
                }}
              >
                {columns.length > 0 ? (
                  <DataGrid
                    rows={filteredRows}
                    columns={columns}
                    disableColumnSelector
                    disableRowSelectionOnClick
                    initialState={{
                      pagination: {
                        paginationModel: {
                          pageSize: 15,
                        },
                      },
                    }}
                    pageSizeOptions={[15]}
                    // onRowClick={handleRowClick}
                    sx={{
                      "& .MuiDataGrid-cell:focus": {
                        outline: "none",
                      },
                      "& .MuiDataGrid-row:hover": {
                        cursor: "pointer",
                      },
                    }}
                  />
                ) : (
                  <Typography variant="body1" gutterBottom align="center">
                    No prompts
                  </Typography>
                )}
              </Box>
            </Paper>
          </Grid2>
        </Grid2>
      </Grid2>
      {loading && <LoadingOverlay />}
  <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
          <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: "100%" }}
            variant="filled">
            {snackbar.message}
          </Alert>
        </Snackbar>

      <DeleteConfirmationModal
      open={deleteModalOpen}
      onClose={()=>{
        setDeleteModalOpen(false);
        setSelectedPromptDelete(null);
      }}
      text="Are you sure you want to delete this content? Deleting it will also remove it from any referenced fields."
      onConfirm={handleConfirmDelete}
      deleteButtonLabel="Delete"
      />
      <CreatePromptForm
          isOpen={modalOpen}
          onClose={() => {
            setModalOpen(false);
          }}
          onSuccess={handlePopupSuccess}

      />
      <EditPromptForm
      isOpen={openEditModal}
      onClose={handleEditModalClose}
      promptId={selectedPromptId}
      onSuccess={handlePopupSuccess}
      workspaceId={workspaceId}
      />

    </Grid2>
  );
};

export default PromptLibrary;
